import React from 'react';

import { GeneratedByEnum, Maybe } from '@/types/schema';

import AddContentsLayout from '../components/AddContents/AddContentsLayout';

export interface RenderAddContentProps {
  label: {
    title: string;
    description: string;
    actionText: string;
    deleteText: string;
    modal?: {
      title?: string;
      description?: string;
      primaryButtonText?: string;
    };
  };
  disabled?: boolean;
  className?: string;
  shareable?: boolean;
  generatedBy?: Maybe<GeneratedByEnum>;
  isPreWorkPostWorkRequired?: boolean;
}

// todo use this renderer at all places where all contents modal is used
export const renderAddContents = (props: RenderAddContentProps) => (formikData: any) => {
  const { value, onChange } = formikData;
  return <AddContentsLayout {...props} value={value} onChange={onChange} />;
};
